export default 'redux-responsive/CALCULATE_RESPONSIVE_STATE';